import React from 'react'
import { generatePath, useNavigate, useParams } from 'react-router-dom'
import PropTypes from 'prop-types'

import Divider from '~/components/Divider'
import Tabs from '~/components/Tabs'
import { PURCHASE_ORDER_DETAIL_PATH } from '~/constants/routes'
import { PURCHASE_ORDER_DETAIL_TABS } from '~/constants/tabs'

const tabs = [
  { value: PURCHASE_ORDER_DETAIL_TABS.GENERAL, label: 'General' },
  { value: PURCHASE_ORDER_DETAIL_TABS.GATE_PASS, label: 'Gate Pass' },
  { value: PURCHASE_ORDER_DETAIL_TABS.HISTORY, label: 'History' }
]

function PurchaseOrderDetailTabs ({ value }) {
  const { guid } = useParams()

  const navigate = useNavigate()

  const onChange = (event, tab) => {
    const redirect = generatePath(PURCHASE_ORDER_DETAIL_PATH, { guid, tab })
    navigate(redirect, { replace: true })
  }

  return (
    <>
      <Tabs
        tabs={tabs}
        value={value}
        onChange={onChange}
      />

      <Divider />
    </>
  )
}
PurchaseOrderDetailTabs.propTypes = {
  value: PropTypes.string.isRequired
}
export default PurchaseOrderDetailTabs
